module.exports = __webpack_public_path__ + "static/media/tb_twkz.dd1d768b.pdf";